import { useTranslation } from "react-i18next";
import { LocalizedLink } from "@/i18n/language";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import { img } from "@/lib/images";

const infoCards = [
  {
    id: "general",
    titleKey: "bali_info_card_general_title",
    descKey: "bali_info_card_general_desc",
    img: img("bali-info/general/header-general-01.jpg"),
    to: "/bali-info/general",
  },
  {
    id: "about-bali",
    titleKey: "bali_info_card_about_title",
    descKey: "bali_info_card_about_desc",
    img: img("bali-info/about-bali/header-about-bali-01.jpg"),
    to: "/bali-info/about-bali",
  },
  {
    id: "books",
    titleKey: "bali_info_card_books_title",
    descKey: "bali_info_card_books_desc",
    img: img("bali-info/books/header-books-01.jpg"),
    to: "/bali-info/books",
  },
  {
    id: "plants",
    titleKey: "bali_info_card_plants_title",
    descKey: "bali_info_card_plants_desc",
    img: "https://readdy.ai/api/search-image?query=Lush%20tropical%20plants%20of%20Bali%2C%20large%20banana%20leaves%2C%20heliconia%20blooms%20and%20bamboo%20in%20soft%20green%20morning%20light%2C%20botanical%20editorial%20photography%2C%20rich%20green%20tones%2C%20shallow%20depth%20of%20field&width=1200&height=800&seq=bali-info-plants-card-01&orientation=landscape",
    to: "/bali-info/plants",
  },
  {
    id: "fruits",
    titleKey: "bali_info_card_fruits_title",
    descKey: "bali_info_card_fruits_desc",
    img: "https://readdy.ai/api/search-image?query=Tropical%20fruit%20arrangement%20on%20a%20wooden%20table%20with%20mango%2C%20rambutan%2C%20mangosteen%2C%20bananas%20and%20papaya%2C%20warm%20natural%20light%2C%20simple%20neutral%20background%2C%20editorial%20food%20photography%2C%20fresh%20and%20vivid%20colours&width=1200&height=800&seq=bali-info-fruits-card-01&orientation=landscape",
    to: "/bali-info/fruits",
  },
  {
    id: "spices",
    titleKey: "bali_info_card_spices_title",
    descKey: "bali_info_card_spices_desc",
    img: "https://readdy.ai/api/search-image?query=Small%20ceramic%20bowls%20filled%20with%20cloves%2C%20nutmeg%2C%20cinnamon%20sticks%2C%20star%20anise%20and%20turmeric%20root%20on%20a%20rustic%20wooden%20surface%2C%20warm%20earthy%20tones%2C%20soft%20side%20light%2C%20editorial%20still%20life%20photography&width=1200&height=800&seq=bali-info-spices-card-01&orientation=landscape",
    to: "/bali-info/spices",
  },
  {
    id: "rice",
    titleKey: "bali_info_card_rice_title",
    descKey: "bali_info_card_rice_desc",
    img: img("balivwtour/rice/rice-terrasses-01.jpg"),
    to: "/bali-info/rice",
  },
];

export default function BaliInfoPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Navbar />
      <main>
        <PageHeader
          eyebrow={t("bali_info_overview_eyebrow")}
          title={t("bali_info_overview_title")}
          subtitle={t("bali_info_overview_intro")}
          image={img("bali-info/header-bali-info-01.jpg")}
          imageAlt="Bali travel information"
        />

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              {infoCards.map((card) => (
                <div
                  key={card.id}
                  className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-accent-600 transition-all"
                >
                  <div className="relative h-60 md:h-96 overflow-hidden">
                    <img
                      src={card.img}
                      alt={t(card.titleKey)}
                      className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="font-heading text-xl md:text-2xl text-foreground-950 mb-2">
                      {t(card.titleKey)}
                    </h3>
                    <div className="w-10 h-0.5 bg-accent-500 mb-4"></div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-5">
                      {t(card.descKey)}
                    </p>
                    <LocalizedLink
                      to={card.to}
                      className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-100 text-background-50 hover:text-foreground-950 text-sm font-medium px-5 py-2.5 rounded-md whitespace-nowrap cursor-pointer transition-colors"
                    >
                      {t("read_more")}
                      <i className="ri-arrow-right-line"></i>
                    </LocalizedLink>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}